require('../../modules/es6.object.is');
module.exports = require('../../modules/_core').Object.is;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/is.js
// module id = 709
// module chunks = 0